export default __webpack_public_path__ + "e5b954db791253e59478c2c1dafa2752.svg";